import { ChevronDown } from 'lucide-react';

import useJobQuoteCollapsible from './useJobQuoteCollapsible';

import JobQuoteBreakdown from '../JobQuoteBreakdown';
import JobQuoteHeader from '../JobQuoteHeader';
import JobQuotePrices from '../JobQuotePrices';

const JobQuoteCollapsible: React.FunctionComponent = function () {
  const { collapseRef, iconClassName, buttonText, onClick, contentStyle } =
    useJobQuoteCollapsible();
  return (
    <div className="flex flex-col bg-neutral-000 rounded-xl shadow-lg overflow-hidden">
      <JobQuoteHeader />
      <div className="overflow-hidden" style={contentStyle}>
        <div className="flex flex-col bg-neutral-000" ref={collapseRef}>
          <JobQuoteBreakdown />
        </div>
      </div>
      <JobQuotePrices />
      <div className="">
        <button
          type="button"
          id="job-quote-collapse-close"
          onClick={onClick}
          className="flex flex-row gap-x-3 px-4 py-2 mx-auto rounded hover:bg-neutral-200 mb-3 text-neutral-600 text-12-18"
        >
          <p>{buttonText}</p>
          <ChevronDown size={20} className={iconClassName} />
        </button>
      </div>
    </div>
  );
};

export default JobQuoteCollapsible;
